import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from '@material-ui/core/Dialog'
import styled, { keyframes } from "styled-components";
import Lottie from 'react-lottie';
import Grid from "@material-ui/core/Grid";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { colors } from "../styles";

import BuccaneerHeader, { LoginButton } from "../components/Home/BuccaneerHeader";
import PageLoader from "../components/Home/PageLoader";
import Label from "../components/Label"
import Footer from "../components/Footer"
import sectionOneImg from "../assets/images/sectionOneImg.png";
import CloseIcon from "../assets/pepper/close-button.png"
import headerImg from "../assets/pepper/headerImg.png";
import smallPepper from "../assets/pepper/smallPepper.png";
import sectionTwoRightImg from "../assets/images/sectionTwoRightImg.png";
import sectionThreeRightImg from "../assets/pepper/roadmap.png";
import sectionThreeTokenomicsImg from "../assets/pepper/tokenomics.png";
import fireBar from "../assets/pepper/fireBar.png";
import twitter from "../assets/images/twitter.png";
import discord from "../assets/images/discord.png";
import telegram from "../assets/images/telegram.png";
import animationData from '../assets/campingfire.json'
import fireAnimationData from '../assets/fireBarAnim.json'
import jeronimo from '../assets/showcase/jeronimo.png'
import cyrus from '../assets/showcase/cyrus.png'
import jayden from '../assets/showcase/jayden.png'
import branton from '../assets/showcase/branton.png'
import cofounder from '../assets/showcase/cofounder.png'
import developer from '../assets/showcase/developer.png'
import egan from '../assets/showcase/egan.png'
import graphicDesigner from '../assets/showcase/graphicDesigner.png'
import marketing from '../assets/showcase/marketing.png'
import parachute from '../assets/showcase/parachute.png'

import gangCofounder2 from '../assets/gang/cofounder2.png'
import gangCofounder from '../assets/gang/cofounder.png'
import gangMarketing from '../assets/gang/marketing.png'
import gangDesigner from '../assets/gang/designer.png'
import gangDeveloper from '../assets/gang/developer.png'
import thermometerImg from '../assets/pepper/thermometerImg.png'
import nft1 from '../assets/images/nft1.png'
import nft2 from '../assets/images/nft2.png'
import nft3 from '../assets/images/nft3.png'
import nft4 from '../assets/images/nft4.png'
import nft5 from '../assets/images/nft5.png'
import nft6 from '../assets/images/nft6.png'
import nft7 from '../assets/images/nft7.png'
import nft8 from '../assets/images/nft8.png'
import avatar from '../assets/images/avatar.png'
import bnb from '../assets/images/bnb.png'
import "./particle.css";

const useStyles = makeStyles((theme) => ({
  particlesContainer: {
    width: "100%",
    height: "90vh",
    position: "absolute",
    left: 0,
    top: 0,
    [theme.breakpoints.down("sm")]: {
      height: "100vh",
    },
  },
  motherWrap: {
    position: "relative",
    width: "100%",
    left: 0,
    right: 0,
    backgroundSize: "cover",
    padding: 0,
  },
  nftSection: {
    display: "flex",
    justifyContent: "center",
  },
  sectionOne: {
    // width: "100%",
    // backgroundImage: `url(${sectionOneImg})`,
    // backgroundSize: "cover",
    alignItems: "center",
    // height: '100vh',
    display: "flex",
    overflow: "hidden",
    marginTop: -100
  },
  textWrap: {
    width: "100%",
    position: "absolute",
    top: 150,
    padding: "0 5%",
    textAlign: "center",
  },
  textItem1: {
    fontSize: 50,
    zIndex: 999,
    textTransform: 'uppercase',
  },
  textItem2: {
    fontSize: "44px",
    fontWeight: 700,
  },
  sectionTwo: {
    width: "100%",
    minHeight: "80vh",
    alignItems: "center",
    display: "flex",
    marginTop: 100,
    zIndex: 3,
  },
  subWrapText: {
    margin: "auto",
    padding: "2% !important",
  },
  subWrapImg: {
    margin: "auto",
    padding: "2% !important",
    textAlign: "center",
  },
  imgs: {
    width: "90%",
    maxWidth: 447
  },
  whyWheText: {
    color: "white",
    fontSize: 60,
    marginBottom: 50,
    textTransform: "uppercase",
  },
  whyWheSubText: {
    color: "white",
    fontSize: 18,
  },
  whyWheQueText: {
    color: "#D81DFA",
    fontSize: "24px",
    fontWeight: 700,
  },
  sectionThree: {
    width: "100%",
    minHeight: "60vh",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    padding: "5% 0",
  },
  title3Wrap: {
    width: "100%",
    padding: "0 5% 0 5% !important",
    alignItems: "center",
    textAlign: "center",
    color: "white",
    marginTop: "2em",
  },
  sliderWrap: {
    width: "100%",
    alignItems: "center",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      width: "90%",
      margin: "0 auto",
    },
  },
  gangWrap: {
    width: "100%",
    alignItems: "center",
    justifyContent: 'center',
    display: "flex",
    flexWrap: "wrap",
    [theme.breakpoints.down("md")]: {
      width: "90%",
      margin: "0 auto",
    },
  },
  roadmapWrap: {
    width: "100%",
    paddingLeft: 0,
    alignItems: "center",
    textAlign: "center",
    color: "white",
    marginTop: "2em",
  },
  textTokenomics: {
    fontSize: "46px",
  },
  subWrapImgPie: {
    margin: "auto",
    padding: "2% !important",
    textAlign: "center",
  },
  rewardBox: {
    width: "100%",
  },
  rewardSubWrap: {
    textAlign: "center",
    borderStyle: "solid",
    borderColor: "#d065d6",
    borderRadius: "10px",
    borderWidth: "2.5px",
    backgroundColor: "#f0f8ff1a",
    padding: "4%",
    minHeight: "370px",
  },
  rewardSubTitle: {
    color: "white",
    fontSize: "22px",
    fontWeight: 700,
  },
  rewardSubUnderline: {
    width: "50%",
    height: "3px",
    backgroundColor: "#23ffff",
    marginLeft: "25%",
  },
  rewardContents: {
    width: "100%",
    textAlign: "left",
    marginTop: "2em",
  },
  rewardContentItem: {
    display: "flex",
    marginTop: "10px",
  },
  rewardText: {
    marginLeft: "5px",
    marginTop: "-3px",
    color: "white",
  },
  pointerImg: {
    maxHeight: "18px",
  },
  stepContents: {
    textAlign: "center",
    color: "white",
    lineHeight: "1.25em",
  },
  stepWrap: {
    textAlign: "center",
    borderStyle: "solid",
    borderColor: "#d065d6",
    borderRadius: "10px",
    borderWidth: "2.5px",
    backgroundColor: "#f0f8ff1a",
    padding: "6% 2%",
    minHeight: "190px",
    width: "100%",
  },
  stepLinked: {
    color: "#d81dfa",
    textDecoration: "underline",
  },
  addressText: {
    color: "white",
    fontSize: "24px",
  },
  tokenText: {
    color: "white",
    fontSize: "18px",
    marginRight: "0.5em",
  },
  tokenWrap: {
    width: "100%",
    justifyContent: "center",
    display: "flex",
  },
  copyImg: {
    maxHeight: "25px",
    maxWidth: "25px",
    marginTop: "auto",
    marginBottom: "auto",
    cursor: "pointer",
    "&:active": {
      opacity: 0.7,
    },
  },
  buyButton: {
    backgroundColor: "#d81dfa",
    color: "white",
    padding: "20px 30px",
    borderRadius: "10px",
    fontSize: "18px",
    "&:hover": {
      cursor: "pointer",
    },
  },
  buttonWrap: {
    textAlign: "center",
    width: "100%",
  },
  contact: {
    marginTop: "10px",
    color: "white",
    fontSize: "16px",
  },
  footerWrap: {
    width: " 100%",
    textAlign: "center",
    color: "white",
    borderStyle: "solid",
    borderWidth: "0",
    borderTopWidth: "1px",
    borderColor: "#bc4bff",
    padding: "1.5em 0",
  },
  [theme.breakpoints.down("xs")]: {},
  [theme.breakpoints.down("sm")]: {
    textItem1: {
      fontSize: "26px",
    },
    textItem2: {
      fontSize: "28px",
      fontWeight: 700,
    },
    subWrapText: {
      padding: "10% !important",
    },
    subWrapImgPie: {
      marginTop: "-2em",
    },
    tokenText: {
      fontSize: "10px",
    },
    whyWheText: {
      fontSize: "40px",
    },
    textTokenomics: {
      fontSize: "40px",
    },
  },
  [theme.breakpoints.up("md")]: {},
  [theme.breakpoints.up("lg")]: {},
}));

const SocialIcon = styled.img`
  margin: 0.5em;
  cursor: pointer;
`;

const SectOneBg = styled.img`
  width: 100%;
  min-height: 900px;
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (max-width: 960px) {
    background-size: cover;
  }
`
const HeadTitle = styled.p`
  background: -webkit-linear-gradient(${colors.main}, ${colors.secondary});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`
const flyingAnim = () => keyframes`
  from {
    transform: rotate(-5deg);
  }
  50% {
    transform: rotate(5deg);
  }
  to {
    transform: rotate(-5deg);
  }  
`
const StyledHeaderImage = styled.img`
  animation: ${flyingAnim} 3.5s ease-in-out infinite;
`
const WhiteListButton = styled.div`
  width: 285px;
  height: 55px;
  border-radius: 10px;
  background: -webkit-linear-gradient(${colors.secondary}, ${colors.main});
  color: white;
  font-size: 22px;
  font-family: "Poppins-Medium", "sans-serif";
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1em auto;
  cursor: pointer;
  &:hover {
    background: -webkit-linear-gradient(${colors.main}, ${colors.secondary});
  }
  &:active {
    transform: translateY(1px);
  }
`
const SmallPepper = styled.img`
  margin-right: 1em;
`
const RoadmapImgContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  @media (max-width: 960px) {
    justify-content: center;
  }
  @media (max-width: 600px) {
    align-items: center;
    flex-direction: column;
  }
`
const StyledLottie = styled.div`
  min-width: 280px;
  height: 215px;
`
const RoadmapImg = styled.img`
  width: 100%;
  z-index: 2;
  max-width: 510px;
  @media (max-width: 1440px) {
    max-width: 410px;
  }
`
const ThermometerImg = styled.img`
  height: 645px;
  z-index: 2;
  @media (max-width: 960px) {
    height: 410px;
  }
`
const TokenomicsText = styled.span`
  font-size: 22px;
  font-family: "Poppins-SemiBold", sans-serif;
  color: white;
  @media (max-width: 600px) {
    font-size: 18px;
  }
`
const TokenomicsValue = styled(TokenomicsText)`
  color: #FEC95A;
`
const TokenomicSubTitle = styled.p`
  font-size: 40px;
  color: #FEC95A;
`
const ShowCard = styled.div`
  width: 280px !important;
  height: 280px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #0E0E11;
  img {
    width: 210px !important;
    margin: auto;
  }
`
const GangCard = styled(ShowCard)`
  width: 240px !important;
  height: 240px !important;
`
const FireBarImg = styled.div`
  margin: 100px 0;
  width: 100%;
  height: 121px;
  background-image: url(${fireBar});
`
const GangItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 12px;
  P:nth-child(2) {
    background: -webkit-linear-gradient(${colors.main}, ${colors.secondary});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 19px;
    text-transform: uppercase;
  }
  p:nth-child(3) {
    font-size: 16px;
    color: #FEC95A;
    text-transform: uppercase;
  }
`
const GradientBorderCard = styled.div`
  padding: 2px;
  background: linear-gradient(${colors.main}, ${colors.secondary});
  max-width: 284px;
`
const PepperTitle = styled.div`
  margin: 70px 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  span { color: white; }
`
const FlameShadow = styled.div`
  background: linear-gradient(#0000, #000);;
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 50%;
`
const GifContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
`
const Slogan = styled(HeadTitle)`
  background: -webkit-linear-gradient(${colors.secondary}, ${colors.greenGrad});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`
const LogoText = styled.p`
  background: -webkit-linear-gradient(${colors.secondary}, ${colors.greenGrad});
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 40px;
`
const DialogWrapper = styled.div<{ open: boolean }>`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  backdrop-filter: blur(8px);
  background: #0003;
  z-index: 997;
  display: ${props => props.open ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
`
const DialogBox = styled.div`
  background: #0009;
  backdrop-filter: blur(4px);
  border-radius: 8px;
  width: 94%;
  max-height: 90vh;
  overflow: auto;
  max-width: 600px;
  padding: 1em;
  min-width: 340px;
  border: 1px solid white;
  p {
    font-family: "Poppins-Medium";
    color: white;
  }
`
const DialogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid white;
  P {
    font-size: 36px;
    font-weight: 700;
  }
`
const DialogContent = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
`
const DialogCloseWrap = styled.div`
  cursor: pointer;
  width: 30px;
  height: 30px;
  img {
    &:active {
      transform: translateY(1px);
    }
  }
  &:hover {
    transform: scale(1.05);
  }
`
const CustomInput = styled.input`
  width: 100%;
  height: 50px;
  border-radius: 8px;
  padding: 0 1em;
  margin: 3px 0 8px 0;
  border: none;
  outline: none;
  font-family: "Poppins-Medium";
  &:hover {
    border: 1px solid ${colors.main};
  }
`
const SuccessMsg = styled.p`
  color: white;
  font-size: 28px;
  text-align: center;
`
const Common = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const Row = styled(Common) <{ alignCenter?: boolean }>`
  flex-direction: row;
  justify-content: ${props => props.alignCenter ? 'center' : 'flex-start'};
  margin: 10px 0;
`
export const SpaceBetween = styled(Common) <{ alignCenter?: boolean }>`
  justify-content: ${props => props.alignCenter ? 'center' : 'space-between'};
`
const SmallTitle = styled.span`
  color: #991B1B;
  font-size: 14px;
`
const Title = styled.p`
  font-size: 56px;
  color: white;
  font-weight: bold;
  margin: 0;
  @media (max-width: 960px) {
    font-size: 30px;
  }
`
export const SubTitle = styled.p`
  font-size: 18px;
  color: #FFFA;
  @media (max-width: 960px) {
    font-size: 14px;
  }
`
const SectionImage = styled.img`
  @media (max-width: 599px) {
    max-width: 300px !important;
    background-size: contain;
  }
`
export const FilterDiv = styled.div`
  width: 100%;
  // height: 92px;
  background: #26292D;
  padding: 1em 0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: 960px) {
    align-items: center;
    justify-content: center;
  }
`
export const CategoryItem = styled(Common)`
  width: 120px;
  height: 52px;
  border-radius: 26px;
  margin: 0 1em;
  &:hover {
    cursor: pointer;
    text-shadow: 1px 1px 9px white, 0 0 2em white, 0 0 1em darkblue;
  }
  p {
    font-size: 16px;
    font-weight: 500;
  }
`
export const NftCard = styled.div`
  position: relative;
  width: 100%;
  max-width: 303px;
  min-width: 280px;
  min-height: 430px;
  border-radius: 8px;
  background: #25282C;
  margin: 1em auto;
  box-shadow: 0px 0px 15px #111;
  img:nth-child(1) {
    width: 100%;
    height: 268px;
  }
  img:nth-child(2) {
    width: 47px;
    height: 47px;
    border-radius: 23.5px;
    position: absolute;
    top: 247px;
    left: 20px;
  }
`
export const InfoWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 15px;
`
export const TimeLeft = styled(Common)`
  width: 143px;
  height: 36px;
  background: #36383C;
  border: 1px solid #86888B;
  border-radius: 18px;
`
export const PlaceBid = styled(Common)`
  background: #B91C1C;
  height: 36px;
  border-radius: 18px;
  padding: 0 15px;
  min-width: 110px;
  cursor: pointer;
  &:hover {
    text-shadow: 1px 1px 9px white, 0 0 2em white, 0 0 1em darkblue;
  }
  &:active {
    transform: translateY(1px);
  }
`

interface Props {
  connect: () => void;
  setIsHide: (e: any) => void;
  killSession: () => void;
  isHide: boolean;
  connected: boolean;
  address: string;
  chainId: number;
}


const Home = (props: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false)
  const [twitterHandle, setTwitterHandle] = useState("")
  const [telegramHandle, setTelegramHandle] = useState("")
  const [discordHandle, setDiscordHandle] = useState("")
  const [bscAddress, setBscAddress] = useState("")
  const [activeCategory, setActiveCategory] = useState(0)

  const Category = ["Main", "BIOS", "Buy Now", "Sold", "Trending", "Latest"]
  const NFTData = [
    { id: 1, url: nft1, title: "A King's Burden", price: 2, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 2, url: nft2, title: "A King's Burden", price: 3, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 3, url: nft3, title: "A King's Burden", price: 4, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 4, url: nft4, title: "A King's Burden", price: 4, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 5, url: nft5, title: "A King's Burden", price: 5, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 6, url: nft6, title: "A King's Burden", price: 6, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 7, url: nft7, title: "A King's Burden", price: 7, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 8, url: nft8, title: "A King's Burden", price: 8, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 9, url: nft1, title: "A King's Burden", price: 2, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 10, url: nft2, title: "A King's Burden", price: 3, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 11, url: nft3, title: "A King's Burden", price: 4, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 12, url: nft4, title: "A King's Burden", price: 4, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 13, url: nft5, title: "A King's Burden", price: 5, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 14, url: nft6, title: "A King's Burden", price: 6, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 15, url: nft7, title: "A King's Burden", price: 7, timeLeft: "01d:00h:23m", avatarUrl: avatar },
    { id: 16, url: nft8, title: "A King's Burden", price: 8, timeLeft: "01d:00h:23m", avatarUrl: avatar },
  ]

  const classes = useStyles();
  const closeDialog = () => setOpenDialog(false)
  const submitInfo = async () => {
    if (twitterHandle == "" || telegramHandle == "" || discordHandle == "" || bscAddress == "") {
      alert("Please fill all fields.")
    } else {
      try {
        setIsLoading(true)
        const response = await fetch(`${process.env.REACT_APP_MY_API}?tabId=Sheet1`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify([[twitterHandle, telegramHandle, discordHandle, bscAddress, new Date().toLocaleString(), new Date().toISOString()]])
        })
        await response.json()
        setIsLoading(false)
        setTwitterHandle("")
        setTelegramHandle("")
        setDiscordHandle("")
        setBscAddress("")
        setOpenDialog(false)
        setOpenSuccessDialog(true)
      } catch (error) {
        console.log('submit error=>', error)
      }
    }

  }

  return (
    <Container className={classes.motherWrap} maxWidth="xl">
      {isLoading && <PageLoader />}
      <DialogWrapper open={openDialog}>
        <DialogBox>
          <DialogHeader>
            <p>Join Whitelist</p>
            <DialogCloseWrap onClick={closeDialog}>
              <img src={CloseIcon} alt="close-icon" />
            </DialogCloseWrap>
          </DialogHeader>
          <DialogContent>
            <p>Twitter</p>
            <CustomInput value={twitterHandle} onChange={(e) => setTwitterHandle(e.target.value)} />
            <p>Telegram</p>
            <CustomInput value={telegramHandle} onChange={(e) => setTelegramHandle(e.target.value)} />
            <p>Discord</p>
            <CustomInput value={discordHandle} onChange={(e) => setDiscordHandle(e.target.value)} />
            <p>BSC address</p>
            <CustomInput value={bscAddress} onChange={(e) => setBscAddress(e.target.value)} />
            <WhiteListButton onClick={submitInfo}>Submit</WhiteListButton>
          </DialogContent>
        </DialogBox>
      </DialogWrapper>

      <DialogWrapper open={openSuccessDialog}>
        <DialogBox>
          <DialogContent>
            <SuccessMsg>You were successfully added to whitelist</SuccessMsg>
            <WhiteListButton onClick={() => setOpenSuccessDialog(false)}>OK</WhiteListButton>
          </DialogContent>
        </DialogBox>
      </DialogWrapper>

      <BuccaneerHeader
        connect={props.connect}
        isHide={props.isHide}
        setIsHide={(e: any) => props.setIsHide(e)}
        connected={props.connected}
        address={props.address}
        chainId={props.chainId}
        killSession={props.killSession}
      />
      <Grid container>
        <Grid item md={12} className={classes.sectionOne}>
          <GifContainer>
            <SectOneBg src={sectionOneImg} alt="sectionOneImg" />
            {/* <FlameShadow>.</FlameShadow> */}
          </GifContainer>

          <Grid id="whypeno" item md={12} className={classes.sectionTwo}>
            <Container maxWidth="lg">
              <Grid container spacing={3}>

                <Grid item xs={12} sm={6} className={classes.subWrapText}>
                  <SmallTitle>Mudi NFT MARKET</SmallTitle>
                  <Title>MUDI ARE </Title>
                  <Title>COMING SOON</Title>
                  <SubTitle>The world's 1st VFX & Metaverse DAO on blockchain. We are creating the content and crafting the stories of the decentralized future.</SubTitle>
                  <LoginButton w="195px" mt="40px" onClick={() => alert(23)}>Explore</LoginButton>
                </Grid>
                <Grid item xs={12} sm={6} className={classes.subWrapImg}>
                  <SectionImage
                    className={classes.imgs}
                    src={sectionTwoRightImg}
                    alt="sss"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FilterDiv>
                    {Category.map((item, index) => (
                      <CategoryItem onClick={() => setActiveCategory(index)} style={{
                        border: `1px solid ${activeCategory === index ? '#B91C1C' : 'transparent'}`
                      }}>
                        <p style={{ color: activeCategory === index ? '#B91C1C' : 'white' }}>{item}</p>
                      </CategoryItem>
                    ))}
                  </FilterDiv>
                </Grid>
              </Grid>
            </Container>
          </Grid>
        </Grid>

        <Grid item md={12} className={classes.sectionTwo}>
          <Container maxWidth="lg">
            <Grid container spacing={3} className={classes.nftSection}>
              {
                NFTData.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} className={classes.NftCardStyle}>
                    <NftCard>
                      <img src={item.url} />
                      <img src={item.avatarUrl} />
                      <InfoWrapper>
                        <Label title={item.title} fs="20px" fw={700} mt="10px" mb="10px" />
                        <Row>
                          <img src={bnb} style={{ width: '20px', height: '20px' }} />
                          <Label title={`${item.price.toFixed(2)}BNB`} color="#E1BF47" ml="10px" fs="14px" />
                        </Row>
                        <SpaceBetween>
                          <TimeLeft>
                            <Label title={`${item.timeLeft} left`} />
                          </TimeLeft>
                          <PlaceBid>
                            <Label title="Place a bid" />
                          </PlaceBid>
                        </SpaceBetween>
                      </InfoWrapper>
                    </NftCard>
                  </Grid>
                ))
              }


            </Grid>
            <LoginButton w="250px" mt="60px" onClick={() => alert('Load More')} style={{ margin: '60px auto' }}>Load More</LoginButton>
          </Container>
        </Grid>


        {/* <Grid id="roadmap" item md={12} className={classes.sectionTwo}>
          <Container maxWidth="lg">
            <Grid container spacing={3}>
              <Grid item sm={12} md={5} className={classes.subWrapImg} style={{ justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <HeadTitle className={classes.whyWheText}>ROADMAP</HeadTitle>
                <div style={{ textAlign: 'left' }}>
                  <span className={classes.whyWheSubText}>
                    <SmallPepper src={smallPepper} alt="smallPepper" /> Peño whitelist Sign Up
                  </span> <br /><br />
                  <span className={classes.whyWheSubText}>
                    <SmallPepper src={smallPepper} alt="smallPepper" /> Peño Presale
                  </span> <br /><br />
                  <span className={classes.whyWheSubText}>
                    <SmallPepper src={smallPepper} alt="smallPepper" /> Peño Pancakeswap LP
                  </span> <br /><br />
                  <span className={classes.whyWheSubText}>
                    <SmallPepper src={smallPepper} alt="smallPepper" /> Peño CG & CMC
                  </span> <br /><br />
                  <span className={classes.whyWheSubText}>
                    <SmallPepper src={smallPepper} alt="smallPepper" /> Peño Staking
                  </span> <br /><br />
                  <span className={classes.whyWheSubText}>
                    <SmallPepper src={smallPepper} alt="smallPepper" /> Peño Buy Back Events  Begin
                  </span> <br /><br />
                  <span className={classes.whyWheSubText}>
                    <SmallPepper src={smallPepper} alt="smallPepper" /> Peño NFT
                  </span> <br /><br />
                </div>
              </Grid>
              <Grid item sm={12} md={7} className={classes.subWrapText}>
                <RoadmapImgContainer>
                  <RoadmapImg
                    src={sectionThreeRightImg}
                    alt="RoadmapImg"
                  />
                  <StyledLottie>
                    <Lottie
                      options={defaultOptions}
                      height={215}
                      width={280}
                    />
                  </StyledLottie>
                </RoadmapImgContainer>
              </Grid>
            </Grid>
          </Container>
        </Grid>
        <Grid id="tokenomics" item md={12} className={classes.sectionThree}>
          <Container maxWidth="lg">
            <Grid container spacing={3}>
              <Grid item sm={12} md={12} className={classes.title3Wrap}>
                <HeadTitle className={classes.whyWheText}>TOKENOMICS</HeadTitle>
              </Grid>
              <Grid item sm={12} md={5} className={classes.subWrapImgPie}>
                <img
                  className={classes.imgs}
                  src={sectionThreeTokenomicsImg}
                  alt="sss"
                />
              </Grid>
              <Grid item sm={12} md={5} className={classes.subWrapText}>
                <TokenomicSubTitle>Total Peño Supply 50 Trillion </TokenomicSubTitle> <br />
                <TokenomicsText>Peño Charity 5% </TokenomicsText> <br />
                <TokenomicsValue>2,500,000,000,000 </TokenomicsValue> <br /><br />
                <TokenomicsText>Peño Staking 35%</TokenomicsText> <br />
                <TokenomicsValue>17,500,000,000,000</TokenomicsValue> <br /><br />
                <TokenomicsText>Spicy Burn 5% At Launch </TokenomicsText> <br />
                <TokenomicsValue>2,500,000,000,000</TokenomicsValue> <br /><br />
                <TokenomicsText>Peño Marketing and growth 15% </TokenomicsText> <br />
                <TokenomicsValue>7,500,000,000,000</TokenomicsValue> <br /><br />
                <TokenomicsText>TEAM TOKENS 15%</TokenomicsText> <br />
                <TokenomicsValue>7,500,000,000,000</TokenomicsValue> <br /><br />
                <TokenomicsText>Peño Early Inverstors,and Burning events 25%</TokenomicsText> <br />
                <TokenomicsValue>12,500,000,000,000</TokenomicsValue>
              </Grid>
            </Grid>
          </Container>
        </Grid>
        <Grid id="showcase" item md={12} className={classes.sectionThree}>
          <Container maxWidth="lg">
            <Grid container spacing={3}>
              <Grid item sm={12} md={12} className={classes.title3Wrap}>
                <HeadTitle className={classes.whyWheText}>SHOWCASE</HeadTitle>
              </Grid>
              <Grid item sm={12} md={12} className={classes.sliderWrap}>
                <Slider {...settings}>
                  {data.map(item => (
                    <GradientBorderCard key={item.id}>
                      <ShowCard>
                        <img src={item.src} alt={item.src} />
                      </ShowCard>
                    </GradientBorderCard>
                  ))}
                </Slider>
              </Grid>

            </Grid>
          </Container>
        </Grid>
        <FireBarImg>.</FireBarImg>
        <Grid id="gang" item md={12} className={classes.sectionThree}>
          <Container maxWidth="lg">
            <Grid container spacing={3}>
              <Grid item sm={12} md={12} className={classes.title3Wrap}>
                <HeadTitle className={classes.whyWheText}>Jalapeño Gang</HeadTitle>
              </Grid>
              <Grid item sm={12} md={12} className={classes.gangWrap}>
                {
                  gangData.map((item: any) => (
                    <GangItem key={item.id}>
                      <GradientBorderCard>
                        <GangCard>
                          <img src={item.src} alt={item.src} />
                        </GangCard>
                      </GradientBorderCard>
                      <p>{item.name}</p>
                      <p>{item.job}</p>
                    </GangItem>
                  ))
                }
              </Grid>

            </Grid>
          </Container>
        </Grid>
        <Grid id="about" item md={12} className={classes.sectionTwo}>
          <Container maxWidth="lg">
            <Grid container spacing={3} style={{ borderBottom: '1px solid #fff8', paddingBottom: '4em' }}>
              <Grid item sm={12} md={8} className={classes.subWrapImg} style={{ justifyContent: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                <HeadTitle className={classes.whyWheText}>About Peño </HeadTitle>
                <div style={{ textAlign: 'left' }}>
                  <span className={classes.whyWheSubText}>
                    Peño is a community-driven meme token on the Binance blockchain
                    designed to reward its members. Our focus is to bring value to our holders by rewarding Peño tokens and helping them build their portfolios by issuing periodic buybacks.
                  </span> <br /><br />
                  <span className={classes.whyWheSubText}>
                    Essentially the more Peño investors stake, the more tokens they earn from other projects.
                    The community will vote on buybacks as milestones are reached. A Peño Thermometer displayed on our website will fill as the price of Peño rises.
                  </span> <br /><br />
                  <span className={classes.whyWheSubText}>
                    Once the Peño Pepper has reached its burning point, staking emission stops, and market buys begin. This process will repeat itself throughout the project's lifetime, and the goal is to promote longevity and valuation.
                  </span> <br /><br />
                  <span className={classes.whyWheSubText}>
                    Peño is the first of its kind. A token solely made to help investors increase their crypto holdings. Deployed on Binance Chain to deter high gas fees
                    and provide a smooth experience while investing.
                  </span> <br /><br />
                </div>
              </Grid>
              <Grid item sm={12} md={4} className={classes.subWrapText}>
                <RoadmapImgContainer>
                  <ThermometerImg
                    src={thermometerImg}
                    alt="thermometerImg"
                  />
                </RoadmapImgContainer>
              </Grid>
            </Grid>
          </Container>
        </Grid>
        <PepperTitle>
          <LogoText>Jalapeño</LogoText>
          <span>Join us</span>
          <div>
            <SocialIcon src={twitter} onClick={() => window.open(twitterLink, "_blank")} />
            <SocialIcon src={discord} onClick={() => window.open(discordLink, "_blank")} />
            <SocialIcon src={telegram} onClick={() => window.open(telegramLink, "_blank")} />
          </div>
        </PepperTitle> */}
      </Grid>
      <hr />
      <Footer />
    </Container>
  );
};

export default Home;
